import { defineMessages } from "react-intl";

const SECRET_QUESTION_SELECT = "secret-question-select";

const secretQuestionSelectMessages = defineMessages({
  label: {
    id: `${SECRET_QUESTION_SELECT}.label`,
    defaultMessage: "Select secret question",
    description:
      "label for dropdown for COPPA users to select a security question to be used in the password reset"
  }
});

export default secretQuestionSelectMessages;
